import React, { createElement } from 'react';
import { useSelector } from 'react-redux';
import Cookies from '../../components/cookies/cookies';
import hotInsuranceLogoPath from '../../assets/logos/hot-insurance-logo.svg';
import homeIconPath from '../../assets/icons/home-icon.svg';
import phoneIconPath from '../../assets/icons/phone-icon.svg';
import './index.scss';

const HOT_WEBSITE_URL = 'https://www.hot.co.il/';

const Header = () => {
    const deviceState = useSelector((store) => store.deviceState.device);
    const insurancePage = useSelector((store) => store.insurancePage);

    const isMobileOrTablet = (deviceState === 'mobile' || deviceState === 'tablet');

    return (
        <header className="header">
            <Cookies />
            <div className="header-container">
                <HeaderButton type="a" href={HOT_WEBSITE_URL} target="_blank">
                    <img src={homeIconPath} alt="Home Icon" className="header-button-icon" />

                    <span className="header-button-text">
                        {insurancePage?.general?.back_to_website}
                    </span>
                </HeaderButton>

                <img src={hotInsuranceLogoPath} alt="Hot Insurance" className="header-logo" />

                <HeaderButton
                    type={isMobileOrTablet ? 'a' : 'div'}
                    href={isMobileOrTablet ? `tel:*${insurancePage?.general?.short_tel}` : null}
                >
                    <img src={phoneIconPath} alt="Phone Icon" className="header-button-icon" />

                    <span className="header-button-text">
                        {`${insurancePage?.general?.short_tel}*`}
                    </span>
                </HeaderButton>
            </div>
        </header>
    );
};

const HeaderButton = ({ type, children, ...remainingProps }) => createElement(type, {
    className: 'header-button',
    ...remainingProps,
}, children);

export default Header;
